import submitCommand from '../../../services/submitCommand';
import cacheService from '../../../services/cacheService';

export const unlockPathwayCourses = (id: string, userId: string) => {
  cacheService.remove(`/v1/workflows/${id}`);
  return submitCommand(
    id,
    {
      id: id,
      initiatingUserId: userId,
    },
    'UnlockWorkflow',
    'WorkflowUnlocked',
    'WorkflowError'
  );
};
